module.exports = __webpack_public_path__ + "static/media/email_unverified.c2674e06.png";